import * as React from "react"

import { SEO } from "."
import Dashboard from "./dashboard"
import AppContainer from "./AppContainer"

const companyName =
  (process.env.GATSBY_COMPANY_NAME || "Bradbury").charAt(0).toUpperCase() +
  (process.env.GATSBY_COMPANY_NAME || "Bradbury").slice(1)

const TITLE = `Welcome To Your ${companyName} Portal`

const DashboardPage: React.FC<{}> = () => (
  <div>
    <SEO title={TITLE} />
    <AppContainer title={TITLE}>
      <Dashboard />
    </AppContainer>
  </div>
)

export default DashboardPage
